import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {DbFilesStateService} from "../../services/db-files-state.service";
import {DesignBlockFilesService} from "../../services/design-block-files.service";
import {DbFilePathStateService} from "../../services/db-file-path-state.service";
import {DeleteFileParams} from "../../../../../types/product-card-files.types";
import {BaseDesignBlockFile} from "../../types/design-block-files.types";
import {EntityFileType} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";

@Component({
  selector: 'div[app-db-file-library]',
  standalone: true,
  imports: [
    FileCardComponent
  ],
  templateUrl: './db-file-library.component.html',
  styleUrl: './db-file-library.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DbFileLibraryComponent {
  designBlockEntityFileType = input<EntityFileType>('LISTING');
  isEditModeActive = input<boolean>(false);

  public dbFilesStateService: DbFilesStateService = inject(DbFilesStateService);
  private designBlockFilesService: DesignBlockFilesService = inject(DesignBlockFilesService);
  private dbFilePathStateService: DbFilePathStateService = inject(DbFilePathStateService);

  public handleDelete(isImage: boolean, file: BaseDesignBlockFile): void {
    const params: DeleteFileParams = {
      path: this.dbFilePathStateService.pathFileState(),
      id: file.id
    };

    this.designBlockFilesService.deleteFile(params)
      .then(() => this.dbFilesStateService.deleteFileById(file.id));
  }
}
